import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
import { StoreProvider } from './ui/StoreContext';
import './styles.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root-Element #root nicht gefunden.');
}

createRoot(container).render(
  <StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </StrictMode>,
);
